<template>
  <main-map
    :all-routes="listRoute"
    :all-routes-from-api="info"
    :route-colors="colorRoute"
    :selected-route-ids="ticked"
    @route-selected="handleRouteSelected"
    @route-deselected="handleRouteDeselected"
  >
  </main-map>

  <route-navigator
    :tree-data="simple"
    :selected-routes="ticked"
    :route-colors="colorRoute"
    :all-routes-from-api="info"
    @route-selected="handleRouteSelected"
    @route-deselected="handleRouteDeselected"
  />
</template>

<script setup>
import {
  defineAsyncComponent, onBeforeMount, onMounted, ref, watch,
} from 'vue';
import preloadImages from '@/components/preload-image';
import RouteNavigator from '@/components/RouteNavigator.vue';
import routeService from '@/services/routeService';
import { generateRandomColor } from '@/utils/colors';

const MainMap = defineAsyncComponent(() => import('@/components/MainMap.vue'));

const info = ref([]);
const ticked = ref([]);
const simple = ref([]);
const listRoute = ref([]);
const colorRoute = ref({});

onBeforeMount(() => {
  preloadImages();
});

const groupByAddressAndShift = (data) => {
  const groupedAddresses = {
    ENTRADAS: [],
    SALIDAS: [],
  };

  groupedAddresses.ENTRADAS = data.filter((route) => route.direccion_ruta === 'ENTRADA');
  groupedAddresses.SALIDAS = data.filter((route) => route.direccion_ruta === 'SALIDA');

  const groupByShift = (routes) => {
    const grouped = {};

    routes.forEach((route) => {
      if (!grouped[route.turno_ruta]) {
        grouped[route.turno_ruta] = [];
      }
      grouped[route.turno_ruta].push(route);
    });

    return Object.entries(grouped).map(([shift, routes]) => ({
      key: `Turno: ${shift}`,
      children: routes.map((route) => ({ key: route.clave_ruta, name: route.nombre_ruta })),
    }));
  };

  return [
    {
      key: 'Rutas: Foxconn',
      children: [
        {
          key: 'Entradas',
          children: groupByShift(groupedAddresses.ENTRADAS),
        },
        {
          key: 'Salidas',
          children: groupByShift(groupedAddresses.SALIDAS),
        },
      ],
    },
  ];
};

onMounted(async () => {
  try {
    const result = await routeService.getRoutes('Foxconn');
    info.value = result;
    simple.value = groupByAddressAndShift(result);
    // eslint-disable-next-line no-console
    console.log('Rutas cargadas:', result.length);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error loading routes:', error);
  }
});

const handleRouteSelected = (routeId) => {
  if (!ticked.value.includes(routeId)) {
    ticked.value.push(routeId);
  }
};

const handleRouteDeselected = (routeId) => {
  const index = ticked.value.indexOf(routeId);
  if (index !== -1) {
    ticked.value.splice(index, 1);
  }
};

watch(ticked, (data) => {
  listRoute.value = info.value.filter((route) => data.includes(route.clave_ruta));

  if (data.length > Object.keys(colorRoute.value).length) {
    data.forEach((id) => {
      if (!colorRoute.value[id]) {
        colorRoute.value[id] = generateRandomColor();
      }
    });
  } else {
    Object.keys(colorRoute.value).forEach((key) => {
      if (!data.includes(key)) {
        delete colorRoute.value[key];
      }
    });
  }
});

</script>

<style scoped>
</style>
